import { LinearProgress, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { BaseOuterContainer } from "@app/analytics/components/reports/styles";

import Stack from "@rui/Stack";

const Overlay = styled(Stack)({
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  backgroundColor: "#FFF",
  zIndex: 99, // must be lower than side nav
});

const LoadingBar = styled(LinearProgress)(({ theme }) => ({
  height: "12px",
  width: "300px",
  borderRadius: "4px",
  backgroundColor: "#FFF",
  border: "1px solid",
  borderColor: theme.palette.shades.primary[500],
}));

const ReportLoading = () => (
  <BaseOuterContainer>
    <Overlay variant="center" spacing={3} flex={1}>
      <Typography>Loading report...</Typography>
      <LoadingBar variant="indeterminate" />
    </Overlay>
  </BaseOuterContainer>
);

export default ReportLoading;
